import axios from 'axios';
import querystring from 'qs';
import summarybar from './summarybar.vue';
import moment from 'moment';
import addsupervisior from './addsupervisior.vue';
export default {
    name: 'ActivityBar',
    props: {
        date: {
            type: Date,
        },
    },
    components: {
        summarybar
    },
    computed: {
        doubleattendant() {
            return this.result.activties.filter(x => x.isDouble == true).length;
        }
    },
    data() {
        return {
            initialized: false,
            result: null,
            overridies:[]
        };
    },
    watch: {
        templateType() {
            this.setEndDate();
        },
        page() {
            this.fetch();
        },
        date() {
            this.fetch();
        }
    },
    mounted() {
        this.fetch();
    },
    methods: {
        fetch() {
            //console.log(this.date)
            this.initialized = false;
            const params = {
                date: this.date,
            };
            let url = APIURL + '/activity/by-date?' + querystring.stringify(params);
            let response = axios.get(url, params)
                .then(resp => {
                    this.result = resp.data;
                    //this.result.activties = this.result.activties.filter(x => x.id == 41409 || x.id == 40911) //
                });
            let overrideurl = APIURL + '/activity/overridies?' + querystring.stringify(params);
            let responseOverride = axios.get(overrideurl, params)
                .then(resp => {
                    this.overridies = resp.data;
                    //this.result.activties = this.result.activties.filter(x => x.id == 41409 || x.id == 40911) //
                });
            Promise.all([response, responseOverride])
                .then(() => {
                    this.initialized = true;
                })
                .catch(error => {
                    console.error('Error fetching data:', error);
                });
        },
        getDate(newdate) {
            //let newdate=moment(this.date).format('YYYY-MM-DD');

            return moment.utc(newdate).format('ddd HH:mm');
        },
        addsupervisor(item) {
            let self = this;
            //console.log(this.$t('title.newactivity'))
            this.$vuedals.open({
                title: this.$t('title.newactivity'),
                props: {
                    item: item,
                },
                component: addsupervisior,
                size: 'lg',
                escapable: true,
                onClose(resp) {
                    self.Add(resp);
                }
            });
        },
        Add(resp) {
            let url = APIURL + '/activity/' + resp.activityId + '/registerattendant';
            let activityPeriodAttendantMaps = [];
            if (resp.activityPeriodId > 0) {
                activityPeriodAttendantMaps.push({ activityPeriodId: resp.activityPeriodId, attendantId: resp.attendantId })
            }
            let saveData = [{
                id: resp.attendantId,
                isGroup: false,
                isApproved: true,
                activityPeriodAttendantMaps: activityPeriodAttendantMaps
            }];
            axios.put(url, saveData)
                .then(resp2 => {
                    this.fetch();
                });
        },
        deleteAttendant(attendantId, periodId, activityId) {
            this.$dialog.confirm(this.$t('confirm.delete'))
                .then(() => {
                    let url = APIURL + '/activity/deleteattendant/' + activityId;
                    let deletedata = {
                        activityPeriodId: periodId,
                        attendantId: attendantId
                    };
                    axios.post(url, deletedata)
                        .then(resp => {
                            this.fetch();
                        });
                })
                .catch(() => { });

        },
        isDoubleUser(item, isperiod) {

            const targetStart = moment.utc(item.startTime).valueOf();
            const targetEnd = moment.utc(item.endTime).valueOf();
            const targetUserIds = new Set(item.attendants.map(u => u.id));

            const hasConflict = this.result.activties.some(event => {
                // Skip comparing against itself when editing an existing event

                if (event.id === item.id && !isperiod) return false;
                if (isperiod && event.id != item.id && event.activityPeriods.length==0) {
                    const eventStart = moment.utc(event.startTime).valueOf();
                    const eventEnd = moment.utc(event.endTime).valueOf();

                    // Skip if timing is exactly the same as target
                    if (eventStart === targetEnd || eventEnd === targetStart) return false;
                    //console.log('eventStart : ' + event.startTime + " targetEnd : " + item.endTime + " eventEnd: " + event.endTime + " targetStart :" + item.startTime);
                    // 1. Time overlap condition
                    const isTimeOverlapping = targetStart < eventEnd && eventStart < targetEnd;
                    //console.log('isTimeOverlapping : ' + isTimeOverlapping);
                    const topLevelConflict = isTimeOverlapping &&
                        (event.attendants || []).some(user => targetUserIds.has(user.id));
                    //console.log('top level : ' + topLevelConflict);

                    if (topLevelConflict) return true;
                }

                // 2. User conflict check
                const periodConflict = (event.activityPeriods || []).some(period => {
                    //console.log('PeriodId : ' + item.activityPeriodId);

                    if (period.activityPeriodId === item.activityPeriodId && isperiod) return false;
                    //console.log('SubPeriod Id  : ' + period.activityPeriodId);
                    //console.log('isperiod' + isperiod);
                    //console.log('period : ' + period.activityPeriodId + ' item periodId : ' + item.activityPeriodId);
                    const subStart = new Date(period.startTime).getTime();
                    const subEnd = new Date(period.endTime).getTime();

                    // Skip if timing is exactly the same as target
                    if (subStart === targetEnd || subEnd === targetStart) return false;

                    const isSubTimeOverlapping = targetStart < subEnd && subStart < targetEnd;
                    if (!isSubTimeOverlapping) return false;

                    return (period.attendants || []).some(user => targetUserIds.has(user.id));
                });
                //console.log('periodConflict : ' + periodConflict);
                return periodConflict;
                //}
            });
            item.isDouble = hasConflict;
            //console.log("conflict found for item : " + item.id + " PeriodId : " + item.activityPeriodId + " value : " + hasConflict)
            return hasConflict;
        },
        isDoubleAttedant(item) {
            let isDouble = item.activityPeriods.some(x => x.isDouble == true)
            item.isDouble = isDouble;
            return isDouble;
        }

    }
};